import { defineAction, number, object, string } from '~/prix'
import llmChatDeleteAction from './llmChatDelete.action.json' with { type: 'json' }
import { z } from 'zod'

const llmChatDeleteDefinition = defineAction({
  ...llmChatDeleteAction,

  input: object({
    id: number(),
  }),
  output: object({}),
})

export default llmChatDeleteDefinition
